import { CSSProperties, useEffect, useState } from 'react';
import { Modal, ModalContent, ModalPortal } from './modal';

interface Props {
  children: React.ReactNode;
  style?: CSSProperties;
  target: string;
  title?: string | React.ReactNode;
}

const ModalEventOnMouseDown = ({ children, style, target, title }: Props) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    document.addEventListener('mousedown', (ev) => handleMouseEvent(ev, true));
    document.addEventListener('mouseup', (ev) => handleMouseEvent(ev, false));

    return () => {
      clearTimeout(mouseEventTimeout);
      document.removeEventListener('mousedown', (ev) =>
        handleMouseEvent(ev, false)
      );
      document.removeEventListener('mouseup', (ev) =>
        handleMouseEvent(ev, false)
      );
    };
  }, []);

  let mouseEventTimeout: NodeJS.Timeout;
  const handleMouseEvent = (ev: MouseEvent, value: boolean) => {
    const eventTarget = ev.target as Node;
    const element = document.getElementById(target);

    if (!element || !eventTarget) return;

    clearTimeout(mouseEventTimeout);
    if (value && (element === eventTarget || element.contains(eventTarget)))
      mouseEventTimeout = setTimeout(() => setVisible(true), 500);
  };

  return (
    <ModalPortal>
      <Modal
        closeButton={true}
        onHide={() => setVisible(false)}
        stopPropagation={true}
        title={title || ''}
        visible={visible}
      >
        <ModalContent style={style}>{children}</ModalContent>
      </Modal>
    </ModalPortal>
  );
};

export default ModalEventOnMouseDown;
